import has from "lodash/has";
import tgamConfig from "config/tgam";
import { getPresetKey } from "lib/commercial/dfp-ads/adslot-size-mapping";
import logger from "utils/logger";

const debugTag = "[MOAT-VIEWABILITY]";
/**
 * Get Moat's Viewability percentage based on the given slotId or position.
 * @param {String} slotId - the slot for the ad
 *  @param {String} pos - ad position
 * @returns {String} the percent range or empty String if not found
 */
export function getMoatViewability(slotId, pos) {
  if (!has(tgamConfig, "adops.moat.viewability.data")) {
    return "";
  }

  const { data } = tgamConfig.adops.moat.viewability;
  const mapSlotId = getPresetKey(slotId);

  const filtered = data.filter(d => {
    // d.level4_id === pos condition is required for rr3+ positions.
    // The mapSlotId for rr3+ is "boxs", "boxs2", etc. so it would never
    // match the filter condition otherwise. Moat returns
    // "rr3" and up for the d.level4_id value.
    return d.level2_id === tgamConfig.adops.pageTargets.bp
            && d.level3_id === tgamConfig.adops.pageTargets.loc
            && (d.level4_id === mapSlotId || d.level4_id === pos);
  });

  logger.info(debugTag, { slotId, pos, mapSlotId, filtered });

  return filtered.length ? filtered[0].in_view_percent_range : "";
}
